import {
  buffers, eventChannel,
} from 'redux-saga';
import {
  call, put, select, take, takeLatest,
} from 'redux-saga/effects';
import {
  type EntityAccessInvitationResponse, getReceivedInvitations,
} from '~/_shared/entityAccess/entityAccess.invitations.repository';
import { entityAccessInvitationResponseToEntityAccessInvitation } from '~/_shared/entityAccess/entityAccess.repository.helpers';
import {
  type EntityAccessInvitationsEvent, registerEntityAccessInvitationsEventsBroadcastListener,
} from '~/_shared/utils/api/broadcast.helpers';
import { noop } from '~/_shared/utils/function.helpers';
import { clientIdSelector } from '~/store/selectors/useClientIdSelector';
import {
  USER_GET_DATA_SUCCESS, USER_WEB_SOCKET_BROADCAST_INITIALIZED,
} from '~/store/userData/userData.actionTypes';
import {
  entityAccessReceivedInvitationsChanged, entityAccessSetReceivedInvitations,
} from './entityAccessInvitations.actionCreators';

export function* entityAccessInvitationsSagas() {
  yield takeLatest(USER_WEB_SOCKET_BROADCAST_INITIALIZED, registerEntityAccessInvitationsEventsListenersSaga);
  yield takeLatest([USER_GET_DATA_SUCCESS, entityAccessReceivedInvitationsChanged], fetchEntityAccessReceivedInvitationsSaga);
}

function* registerEntityAccessInvitationsEventsListenersSaga() {
  const eventsChannel: ReturnType<typeof registerEntityAccessInvitationsBroadcastEventsListener> = yield call(registerEntityAccessInvitationsBroadcastEventsListener);

  while (true) {
    yield take(eventsChannel);
    yield put(entityAccessReceivedInvitationsChanged());
  }
}

function* fetchEntityAccessReceivedInvitationsSaga() {
  const clientId: number = yield select(clientIdSelector);
  if (!clientId) {
    return;
  }

  try {
    const response: { list: ReadonlyArray<EntityAccessInvitationResponse> } = yield call(getReceivedInvitations, clientId);
    const invitations = response.list.map(entityAccessInvitationResponseToEntityAccessInvitation);
    yield put(entityAccessSetReceivedInvitations(invitations));
  }
  catch (error) {
    yield put(entityAccessSetReceivedInvitations([]));
    // Optionally handle error state here
  }
}

const registerEntityAccessInvitationsBroadcastEventsListener = () => {
  return eventChannel<EntityAccessInvitationsEvent>(emitter => {
    registerEntityAccessInvitationsEventsBroadcastListener(
      (e) => emitter(e),
      noop,
    );

    return noop;
  }, buffers.expanding());
};
